// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { useContext, useEffect, useState } from "react";
// import InfiniteScroll from "react-infinite-scroller";
// import LoadingComp from "../../components/common/LoadingComp";
// import { useSelector } from "react-redux";
// import axiosGeneral from "../../utils/axiosGeneral";
// import axiosWithAuth from "../../utils/axiosWithAuth";
// import ListingItem from "./ListingItem";

// import { Col, Radio, Row, Pagination, Divider } from "antd";
// import { useLocation } from "react-router-dom";

// export default function DirectoryListing(props) {
//   const [businesses, setBusinesses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterCurrentPage, setFilterCurrentPage] = useState(0);
//   const [sorting, setSorting] = useState("alphabetical");
//   const [value, setValue] = useState("asc");
//   const search = useLocation().search;
//   const keyword = new URLSearchParams(search).get("keyword");
//   const location = new URLSearchParams(search).get("location");
//   const category = new URLSearchParams(search).get("category");
//   const ratings = new URLSearchParams(search).get("ratings");
//   const tags = new URLSearchParams(search).get("tags");
//   const status = new URLSearchParams(search).get("status");
//   const user = useSelector((state) => state.user.user);
//   const [userRoleAccess, setUserRoleAccess] = useState([]);

//   // State to determine when a user is logged in
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isSearchedData, setIsSearchedData] = useState(false);
//   const [businessesLength, setBusinessesLength] = useState(0);
//   const [isLoader, setIsLoader] = useState(false);

//   useEffect(() => {
//     gsap.registerPlugin(ScrollTrigger);

//     ScrollTrigger.create({
//       trigger: "#load-more",
//       onEnter: (self) => {
//         console.log("Load More", self.isActive);
//       },
//       onLeave: (self) => {
//         console.log("Stop loading more", self.isActive);
//       },
//     });
//   }, []);

//   useEffect(() => {
//     let searchFlag = false;
//     setIsLoader(true);
//     setLoading(true);
//     let APIURL;

//     let locationQuery = "";
//     let nameQuery = "";
//     let CategoryQuery = "";
//     let ratingsQuery = "";
//     let filteredTagQuery = "";
//     let statusQuery = "";

//     if (location) {
//       locationQuery = `&location=${location || ""}`;
//     }
//     if (keyword) {
//       nameQuery = `&keyword=${keyword || ""}`;
//     }
//     if (category) {
//       CategoryQuery = `&category=${category || ""}`;
//     }
//     if (ratings) {
//       ratingsQuery = `&ratings=${ratings || ""}`;
//     }

//     if (tags && tags.length > 0) {
//       filteredTagQuery = `&tags=${tags || ""}`;
//     }
//     if (status) {
//       statusQuery = `&status=${status || ""}`;
//     }

//     if (
//       keyword ||
//       location ||
//       category ||
//       ratings ||
//       (tags && tags.length) ||
//       status
//     ) {
//       searchFlag = true;
//       APIURL = `/api/business/list?searchDataPage=${0}${locationQuery}${nameQuery}&sort=${sorting}&OrderBy=${value}${filteredTagQuery}${statusQuery}`;
//       if (category || ratings) {
//         APIURL = `/api/business/list?searchDataPage=${
//           currentPage - 1
//         }${locationQuery}${nameQuery}${CategoryQuery}${ratingsQuery}&sort=${sorting}&OrderBy=${value}${filteredTagQuery}${statusQuery}`;
//       }
//     } else {
//       // setCurrentPage(1);
//       setIsSearchedData(false);
//       APIURL = `/api/business/list/?page=${currentPage - 1}&tags=${
//         tags || ""
//       }&status=${status || ""}&sort=${sorting}&OrderBy=${value}`;
//     }
//     console.log("currentPage", currentPage);
//     axiosGeneral()
//       .get(APIURL)
//       .then((res) => {
//         if (res && res.status === 200 && res.data.businesses) {
//           // setIsSearchedData(true);
//           setBusinesses(res.data.businesses);
//           setBusinessesLength(res.data.length);
//           // props.onTagList(res.data.tags);
//           getAllTags();
//           if (
//             res.data.businesses.length === 0 ||
//             res.data.businesses.length < 12
//           ) {
//             setLoading(false);
//             // message.info(`Fetched All ${businessesLength} Businesses`)
//           }
//           // if (!searchFlag) {
//           //   console.log("holaaaaaaaaa");
//           //   setCurrentPage(1);
//           // }
//           // else {
//           //   setCurrentPage(1);
//           // }
//         }
//         setIsLoader(false);
//       })
//       .catch((err) => {
//         console.log(err.response);
//         setIsLoader(false);
//       });
//   }, [search, currentPage]);

//   useEffect(() => {
//     // Logic for checking if have an auth token
//     const getToken = JSON.parse(localStorage.getItem("token"));

//     if (getToken) {
//       if ("token" in getToken) {
//         setIsLoggedIn(true);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (isLoggedIn || !userRoleAccess.length) {
//       getUserRoleAccess();
//     }
//   }, [user]);

//   const getUserRoleAccess = async () => {
//     if (user && user.id) {
//       const response = await axiosWithAuth().get(
//         `${process.env.REACT_APP_BE_API_URL}/api/users/roleAccessBusiness`
//       );
//       if (response && response.status == 200) {
//         setUserRoleAccess(response.data);
//       }
//     }
//   };

//   const getAllTags = async () => {
//     const response = await axiosWithAuth().get(
//       `${process.env.REACT_APP_BE_API_URL}/api/business/getTags/type/business`
//     );
//     if (response && response.status === 200) {
//       props.onTagList(response.data);
//     }
//   };

//   const updateCurrentPageState = async () => {
//     setCurrentPage(currentPage + 1);
//   };

//   const loadMoreBusinesses = (page) => {
//     let API_URL = "";

//     let locationQuery = "";
//     let nameQuery = "";
//     let CategoryQuery = "";
//     let ratingsQuery = "";
//     let filteredTagQuery = "";
//     let statusQuery = "";

//     if (location) {
//       locationQuery = `&location=${location || ""}`;
//     }
//     if (keyword) {
//       nameQuery = `&keyword=${keyword || ""}`;
//     }
//     if (category) {
//       CategoryQuery = `&category=${category || ""}`;
//     }
//     if (ratings) {
//       ratingsQuery = `&ratings=${ratings || ""}`;
//     }
//     if (tags && tags.length > 0) {
//       filteredTagQuery = `&tags=${tags || ""}`;
//     }
//     if (status) {
//       statusQuery = `&status=${status || ""}`;
//     }

//     if (
//       search &&
//       (keyword ||
//         category ||
//         location ||
//         category ||
//         ratings ||
//         status ||
//         (tags && tags.length))
//     ) {
//       API_URL = `/api/business/list?searchDataPage=${
//         currentPage - 1
//       }${CategoryQuery}${locationQuery}${nameQuery}${statusQuery}${ratingsQuery}${filteredTagQuery}&sort=${sorting}&OrderBy=${value}`;
//     } else {
//       API_URL = `/api/business/list?page=${
//         currentPage - 1
//       }&sort=${sorting}&OrderBy=${value}`;
//     }

//     axiosGeneral()
//       .get(API_URL)
//       .then((res) => {
//         setBusinesses(businesses.concat(res.data.businesses));
//         setBusinessesLength(res.data.length);
//         if (
//           res.data.businesses.length === 0 ||
//           res.data.businesses.length < 12
//         ) {
//           setLoading(false);
//         }
//         // if (search) {
//         //   setFilterCurrentPage(filterCurrentPage + 1);
//         // } else {
//         setCurrentPage(currentPage + 1);
//         // }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   const handleSorting = async (val) => {
//     setLoading(true);
//     setIsLoader(true);
//     setSorting(val);
//     setValue(value || "asc");
//     let API_URL = "";

//     let locationQuery = "";
//     let nameQuery = "";
//     let CategoryQuery = "";
//     let ratingsQuery = "";
//     let filteredTagQuery = "";
//     let statusQuery = "";

//     if (location) {
//       locationQuery = `&location=${location || ""}`;
//     }
//     if (keyword) {
//       nameQuery = `&keyword=${keyword || ""}`;
//     }
//     if (category) {
//       CategoryQuery = `&category=${category || ""}`;
//     }
//     if (ratings) {
//       ratingsQuery = `&ratings=${ratings || ""}`;
//     }
//     if (tags && tags.length > 0) {
//       filteredTagQuery = `&tags=${tags || ""}`;
//     }
//     if (status) {
//       statusQuery = `&status=${status || ""}`;
//     }

//     if (
//       search &&
//       (keyword ||
//         location ||
//         category ||
//         ratings ||
//         status ||
//         (tags && tags.length))
//     ) {
//       API_URL = `/api/business/list?searchDataPage=${currentPage}${locationQuery}${filteredTagQuery}${nameQuery}${statusQuery}${CategoryQuery}${ratingsQuery}&sort=${val}&OrderBy=${
//         value || "asc"
//       }`;
//     } else {
//       API_URL = `/api/business/list/?page=${0}&sort=${val}&OrderBy=${
//         value || "asc"
//       } `;
//     }

//     const response = await axiosGeneral().get(API_URL);

//     if (response && response.status == 200) {
//       setBusinesses(response.data.businesses);
//       setBusinessesLength(response.data.length);
//       if (
//         response.data.businesses.length == 0 ||
//         response.data.businesses.length < 12
//       ) {
//         setLoading(false);
//       }
//       // if (search) {
//       //   setFilterCurrentPage(1);
//       // } else {
//       setCurrentPage(1);
//       // }
//       setIsLoader(false);
//     }
//   };

//   const onChange = (e) => {
//     setLoading(true);
//     setIsLoader(true);
//     setValue(e.target.value);
//     setSorting(sorting || "alphabetical");
//     if (search) {
//       let SEARCH_DATA_API;

//       let locationQuery = "";
//       let nameQuery = "";
//       let CategoryQuery = "";
//       let ratingsQuery = "";
//       let filteredTagQuery = "";
//       let statusQuery = "";

//       if (location) {
//         locationQuery = `&location=${location || ""}`;
//       }
//       if (keyword) {
//         nameQuery = `&keyword=${keyword || ""}`;
//       }
//       if (category) {
//         CategoryQuery = `&category=${category || ""}`;
//       }
//       if (ratings) {
//         ratingsQuery = `&ratings=${ratings || ""}`;
//       }
//       if (tags && tags.length > 0) {
//         filteredTagQuery = `&tags=${tags || ""}`;
//       }
//       if (status) {
//         statusQuery = `&status=${status || ""}`;
//       }

//       if (
//         keyword ||
//         location ||
//         category ||
//         ratings ||
//         status ||
//         (tags && tags.length)
//       ) {
//         SEARCH_DATA_API = `/api/business/list?keyword=${
//           keyword || ""
//         }&location=${location || ""}&searchDataPage=${currentPage - 1}&sort=${
//           sorting || "alphabetical"
//         }&OrderBy=${e.target.value} `;
//         if (category || ratings) {
//           SEARCH_DATA_API = `/api/business/list?searchDataPage=${
//             currentPage - 1
//           }${locationQuery}${statusQuery}${nameQuery}${filteredTagQuery}${CategoryQuery}${ratingsQuery}&sort=${
//             sorting || "alphabetical"
//           }&OrderBy=${e.target.value}`;
//         }
//       }
//       axiosGeneral()
//         .get(SEARCH_DATA_API)
//         .then((res) => {
//           setBusinesses(res.data.businesses);
//           setBusinessesLength(res.data.length);
//           if (
//             res.data.businesses.length == 0 ||
//             res.data.businesses.length < 12
//           ) {
//             setLoading(false);
//           }
//           setIsLoader(false);
//           // setFilterCurrentPage(1);
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//     } else {
//       const APIURL = `/api/business/list?page=${0}&sort=${
//         sorting || "alphabetical"
//       }&OrderBy=${e.target.value}`;

//       axiosGeneral()
//         .get(APIURL)
//         .then((res) => {
//           setBusinesses(res.data.businesses);
//           setBusinessesLength(res.data.length);
//           if (
//             res.data.businesses.length == 0 ||
//             res.data.businesses.length < 12
//           ) {
//             setLoading(false);
//           }
//           setIsLoader(false);
//           setCurrentPage(1);
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//     }
//   };

//   if (isLoader) {
//     return <div className="loader" id="loader"></div>;
//   } else {
//     return (
//       <div id="directory-listing" className="listing-page">
//         <Divider />
//         <div className="listing-header">
//           <h4 className="results-num">
//             Found{" "}
//             {businesses.length +
//               ((currentPage + 1) * 12 - businesses.length) -
//               ((currentPage + 1) * 12 - businesses.length)}{" "}
//             of {businessesLength} Results
//           </h4>

//           <div className="sort-form">
//             <form>
//               <label>
//                 <span>Sort By</span>

//                 <select
//                   onChange={(e) => handleSorting(e.target.value)}
//                   defaultValue={sorting}
//                 >
//                   <option value="alphabetical">Alphabetical</option>
//                   <option value="latest">Latest</option>
//                   <option value="highest_rated">Highest Rated</option>
//                 </select>
//               </label>
//             </form>

//             <Radio.Group onChange={onChange} value={value}>
//               <Radio value="asc" className="radioVal">
//                 ASC
//               </Radio>
//               <Radio value="desc" className="radioVal">
//                 DESC
//               </Radio>
//             </Radio.Group>
//           </div>
//         </div>

//         <Pagination
//           align="end"
//           current={currentPage}
//           total={businessesLength}
//           pageSize={12}
//           showSizeChanger={false}
//           onChange={(value) => {
//             setCurrentPage(value);
//             // setFilterCurrentPage(value);
//           }}
//         />

//         <Divider />

//         <div className="bizzll-directory">
//           {businesses.length > 0 &&
//             businesses.map((business) => {
//               return (
//                 <ListingItem
//                   key={business.id}
//                   business={business}
//                   userRoleAccess={userRoleAccess}
//                   keyword={keyword}
//                 />
//               );
//             })}
//         </div>

//         <Divider />
//         <div className="listing-header">
//           <h4 className="results-num">
//             Found{" "}
//             {businesses.length +
//               ((currentPage + 1) * 12 - businesses.length) -
//               ((currentPage + 1) * 12 - businesses.length)}{" "}
//             of {businessesLength} Results
//           </h4>

//           <div className="sort-form">
//             <form>
//               <label>
//                 <span>Sort By</span>

//                 <select
//                   onChange={(e) => handleSorting(e.target.value)}
//                   defaultValue={sorting}
//                 >
//                   <option value="alphabetical">Alphabetical</option>
//                   <option value="latest">Latest</option>
//                   <option value="highest_rated">Highest Rated</option>
//                 </select>
//               </label>
//             </form>

//             <Radio.Group onChange={onChange} value={value}>
//               <Radio value="asc" className="radioVal">
//                 ASC
//               </Radio>
//               <Radio value="desc" className="radioVal">
//                 DESC
//               </Radio>
//             </Radio.Group>
//           </div>
//         </div>

//         <Pagination
//           align="end"
//           current={currentPage}
//           total={businessesLength}
//           pageSize={12}
//           showSizeChanger={false}
//           onChange={(value) => {
//             setCurrentPage(value);
//           }}
//         />
//       </div>
//     );
//   }
// }

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import axiosGeneral from "../../utils/axiosGeneral";
import axiosWithAuth from "../../utils/axiosWithAuth";
import ListingItem from "./ListingItem";

import { Radio, Pagination, Divider } from "antd";
import { useLocation } from "react-router-dom";

export default function DirectoryListing(props) {
  const [businesses, setBusinesses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState("alphabetical");
  const [value, setValue] = useState("asc");
  const search = useLocation().search;
  const keyword = new URLSearchParams(search).get("keyword");
  const location = new URLSearchParams(search).get("location");
  const category = new URLSearchParams(search).get("category");
  const ratings = new URLSearchParams(search).get("ratings");
  const tags = new URLSearchParams(search).get("tags");
  const status = new URLSearchParams(search).get("status");
  const user = useSelector((state) => state.user.user);
  const [userRoleAccess, setUserRoleAccess] = useState([]);

  // State to determine when a user is logged in
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [businessesLength, setBusinessesLength] = useState(0);
  const [isLoader, setIsLoader] = useState(false);
  const pageCursorsRef = useRef({});
  const prevSearchRef = useRef(search);
  const prevSortingRef = useRef(sorting);
  const prevValueRef = useRef(value);

  // Backend pagination changes: first page is requested without cursor params.
  // Subsequent pages must send the cursor fields from the previous response.
  const buildOfficeListUrl = (cursor, overrides = {}) => {
    const params = new URLSearchParams();

    if (
      cursor?.lastHasOwner !== undefined &&
      cursor?.lastName !== undefined &&
      cursor?.lastId !== undefined
    ) {
      params.set("lastHasOwner", cursor.lastHasOwner);
      params.set("lastName", cursor.lastName);
      params.set("lastId", cursor.lastId);
    }

    if (location) params.set("location", location);
    if (keyword) params.set("keyword", keyword);
    if (category) params.set("category", category);
    if (ratings) params.set("ratings", ratings);
    if (tags) params.set("tags", tags);
    if (status) params.set("status", status);

    params.set("sort", overrides.sort || sorting);
    params.set("OrderBy", overrides.orderBy || value);

    const query = params.toString();
    return query
      ? `/api/business/list/office/?${query}`
      : `/api/business/list/office/`;
  };

  const getCursorForPage = async (targetPage) => {
    if (targetPage <= 1) return null;
    if (pageCursorsRef.current[targetPage])
      return pageCursorsRef.current[targetPage];

    let cursor = null;
    let cursorPage = 1;

    while (cursorPage < targetPage) {
      const response = await axiosGeneral().get(buildOfficeListUrl(cursor));
      const nextCursor = response?.data?.nextCursor || null;

      pageCursorsRef.current[cursorPage + 1] = nextCursor;

      if (!nextCursor) return null;

      cursor = nextCursor;
      cursorPage += 1;
    }

    return cursor;
  };

  const resetOfficePagination = () => {
    pageCursorsRef.current = {};
    setCurrentPage(1);
  };

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: "#load-more",
      onEnter: (self) => {
        console.log("Load More", self.isActive);
      },
      onLeave: (self) => {
        console.log("Stop loading more", self.isActive);
      },
    });
  }, []);

  useEffect(() => {
    // Si cambia el search, sorting o value, resetear cursors y volver a página 1
    const searchChanged = prevSearchRef.current !== search;
    const sortingChanged = prevSortingRef.current !== sorting;
    const valueChanged = prevValueRef.current !== value;

    if (searchChanged || sortingChanged || valueChanged) {
      pageCursorsRef.current = {};
      prevSearchRef.current = search;
      prevSortingRef.current = sorting;
      prevValueRef.current = value;

      if (currentPage !== 1) {
        setCurrentPage(1);
        return; // el efecto se dispara de nuevo por el cambio de currentPage
      }
    }

    const fetchBusinesses = async () => {
      let cursor = null;

      try {
        setIsLoader(true);

        if (currentPage > 1) {
          cursor = pageCursorsRef.current[currentPage] || null;
          if (!cursor) cursor = await getCursorForPage(currentPage);
        }

        const response = await axiosGeneral().get(buildOfficeListUrl(cursor));

        if (response && response.status === 200 && response.data.businesses) {
          setBusinesses(response.data.businesses);
          setBusinessesLength(response.data.length);

          if (response.data.nextCursor) {
            pageCursorsRef.current[currentPage + 1] = response.data.nextCursor;
          }

          getAllTags();
        }
      } catch (err) {
        console.log(err.response);
      } finally {
        setIsLoader(false);
      }
    };

    fetchBusinesses();
  }, [search, currentPage, sorting, value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Logic for checking if have an auth token
    const getToken = JSON.parse(localStorage.getItem("token"));

    if (getToken) {
      if ("token" in getToken) {
        setIsLoggedIn(true);
      }
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn || !userRoleAccess.length) {
      getUserRoleAccess();
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const getUserRoleAccess = async () => {
    if (user && user.id) {
      const response = await axiosWithAuth().get(
        `${process.env.REACT_APP_BE_API_URL}/api/users/roleAccessBusiness`,
      );
      if (response && response.status === 200) {
        setUserRoleAccess(response.data);
      }
    }
  };

  const getAllTags = async () => {
    const response = await axiosWithAuth().get(
      `${process.env.REACT_APP_BE_API_URL}/api/business/getTags/type/business`,
    );
    if (response && response.status === 200) {
      props.onTagList(response.data);
    }
  };

  const handleSorting = (val) => {
    setIsLoader(true);
    const sortValue = val;
    const orderValue = value || "asc";

    resetOfficePagination();
    setSorting(sortValue);
    setValue(orderValue);
  };

  const onChange = (e) => {
    setIsLoader(true);
    const orderValue = e.target.value;
    const sortValue = sorting || "alphabetical";

    resetOfficePagination();
    setSorting(sortValue);
    setValue(orderValue);
  };

  if (isLoader) {
    return <div className="loader" id="loader"></div>;
  } else {
    return (
      <div id="directory-listing" className="listing-page">
        {/* <Divider /> */}
        <div className="listing-header">
          <h4 className="results-num">
            Found{" "}
            {businesses.length +
              ((currentPage + 1) * 12 - businesses.length) -
              ((currentPage + 1) * 12 - businesses.length)}{" "}
            of {businessesLength} Results
          </h4>

          <div className="sort-form">
            <form>
              <label>
                <span>Sort By</span>

                <select
                  onChange={(e) => handleSorting(e.target.value)}
                  defaultValue={sorting}
                >
                  <option value="alphabetical">Alphabetical</option>
                  <option value="latest">Latest</option>
                  <option value="highest_rated">Highest Rated</option>
                </select>
              </label>
            </form>

            <Radio.Group onChange={onChange} value={value}>
              <Radio value="asc" className="radioVal">
                ASC
              </Radio>
              <Radio value="desc" className="radioVal">
                DESC
              </Radio>
            </Radio.Group>
          </div>
        </div>

        {/* <Pagination
          align="end"
          current={currentPage}
          total={businessesLength}
          pageSize={12}
          showSizeChanger={false}
          onChange={(value) => {
            setCurrentPage(value);
            // setFilterCurrentPage(value);
          }}
        /> */}

        <Pagination
          current={currentPage}
          defaultCurrent={1}
          total={businessesLength}
          pageSize={12}
          showSizeChanger={false}
          className="directory-pagination"
          itemRender={(_, type, originalElement) =>
            type === "prev" || type === "next" ? originalElement : null
          }
          onChange={(val) => setCurrentPage(val)}
        />

        <Divider />

        <div className="bizzll-directory">
          {businesses.length > 0 &&
            businesses.map((business) => {
              return (
                <ListingItem
                  key={business.id}
                  business={business}
                  userRoleAccess={userRoleAccess}
                  keyword={keyword}
                />
              );
            })}
        </div>

        <Divider />
        <div className="listing-header">
          <h4 className="results-num">
            Found{" "}
            {businesses.length +
              ((currentPage + 1) * 12 - businesses.length) -
              ((currentPage + 1) * 12 - businesses.length)}{" "}
            of {businessesLength} Results
          </h4>

          <div className="sort-form">
            <form>
              <label>
                <span>Sort By</span>

                <select
                  onChange={(e) => handleSorting(e.target.value)}
                  defaultValue={sorting}
                >
                  <option value="alphabetical">Alphabetical</option>
                  <option value="latest">Latest</option>
                  <option value="highest_rated">Highest Rated</option>
                </select>
              </label>
            </form>

            <Radio.Group onChange={onChange} value={value}>
              <Radio value="asc" className="radioVal">
                ASC
              </Radio>
              <Radio value="desc" className="radioVal">
                DESC
              </Radio>
            </Radio.Group>
          </div>
        </div>

        <Pagination
          current={currentPage}
          defaultCurrent={1}
          total={businessesLength}
          pageSize={12}
          showSizeChanger={false}
          className="directory-pagination"
          itemRender={(_, type, originalElement) =>
            type === "prev" || type === "next" ? originalElement : null
          }
          onChange={(val) => setCurrentPage(val)}
        />
      </div>
    );
  }
}
